import React, { Fragment, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Portal from 'utils/portal/Portal';
import { areas } from 'constants/areas';
import { withAreaGetter } from 'providers/AreasConsumers';
import { getInt } from 'utils/functions';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_DOCUMENT_TYPES } from 'constants/rightsCodes';

import HeaderLinks from './header/HeaderLinks';
import StateTransitionContainer from './StateTransitionContainer';
import Header from './header/Header';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';

const Route = props => {
  const historyContext = useHistoryWithContext();
  const [documentTypeName, setDocumentTypeName] = useState('');
  const [disabledSave, setDisabledSave] = useState(false);
  const [onSave, setOnSave] = useState({});

  const { getElemByAreaKey } = props;

  const documentTypeId = getInt(props.match.params.documentTypeId);
  const stateTransitionId = getInt(props.match.params.stateTransitionId);

  const onClickClose = useCallback(() => {
    historyContext.push(`/documentTypes/${documentTypeId}/stateTransitions`);
  }, [documentTypeId, historyContext]);

  const onChangedStateTransitionTitle = useCallback(documentTypeName => {
    setDocumentTypeName(documentTypeName);
  }, []);

  const onRedirect = useCallback(
    stateTransitionId => {
      historyContext.push(`/documentTypes/${documentTypeId}/stateTransitions/${stateTransitionId}`);
    },
    [documentTypeId, historyContext]
  );

  const onSaveFnChanged = useCallback((fn, disabledSave) => {
    setOnSave({ fn });
    setDisabledSave(disabledSave);
  }, []);
  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Header title={documentTypeName} />
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <HeaderLinks onClickClose={onClickClose} onSave={onSave.fn} disabledSave={disabledSave} />
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_DOCUMENT_TYPES}>
        <StateTransitionContainer
          documentTypeId={documentTypeId}
          stateTransitionId={stateTransitionId}
          onChangedStateTransitionTitle={onChangedStateTransitionTitle}
          onSaveFnChanged={onSaveFnChanged}
          onRedirect={onRedirect}
        />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired
};

export default withAreaGetter(withRouter(Route));
